import React from "react";

function MysteryToken() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      fill="none"
      viewBox="0 0 40 40"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.8315 2.177C17.6659 -0.725665 22.3341 -0.725665 25.1685 2.177L26.7231 3.76909L28.9481 3.74258C33.0048 3.69426 36.3057 6.99522 36.2574 11.0519L36.2309 13.2769L37.823 14.8315C40.7257 17.6659 40.7257 22.3341 37.823 25.1685L36.2309 26.7231L36.2574 28.9481C36.3057 33.0048 33.0048 36.3057 28.9481 36.2574L26.7231 36.2309L25.1685 37.823C22.3341 40.7257 17.6659 40.7257 14.8315 37.823L13.2769 36.2309L11.0519 36.2574C6.99522 36.3057 3.69426 33.0048 3.74258 28.9481L3.76909 26.7231L2.177 25.1685C-0.725665 22.3341 -0.725665 17.6659 2.177 14.8315L3.76909 13.2769L3.74258 11.0519C3.69426 6.99522 6.99522 3.69426 11.0519 3.74258L13.2769 3.76909L14.8315 2.177ZM15.5197 15.4487C15.2262 15.4487 14.9844 15.2113 15.0008 14.9183C15.2041 11.2706 18.1916 10 20.9175 10C23.9218 10 26.6667 11.5704 26.6667 14.8205C26.6667 17.142 25.3011 18.2482 23.9901 19.245C22.406 20.4468 21.8188 20.8974 21.8188 22.4405V22.6674C21.8188 22.9645 21.578 23.2052 21.281 23.2052H19.5362C19.2421 23.2052 19.0025 22.9689 18.9984 22.6748L18.9921 22.2084C18.9101 20.2146 20.0572 18.9856 21.5047 17.9341C22.7747 16.9782 23.5804 16.35 23.5804 14.9844C23.5804 13.2091 22.2285 12.4717 20.7537 12.4717C19.0268 12.4717 18.058 13.5006 17.8666 14.9121C17.8267 15.2065 17.5905 15.4487 17.2935 15.4487H15.5197ZM20.5215 29.3094C19.2652 29.3094 18.3502 28.4628 18.3502 27.3157C18.3502 26.1276 19.2652 25.2946 20.5215 25.2946C21.8325 25.2946 22.7338 26.1276 22.7338 27.3157C22.7338 28.4628 21.8325 29.3094 20.5215 29.3094Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default MysteryToken;
